<div class="w-100 d-flex justify-content-center align-items-center flex-column">
  @if (hasBackground()) {
    <div class="background">
      <div class="pin-background"></div>
      <ng-lottie
        class="animation"
        [options]="{ path: pinAnimation() }"
      ></ng-lottie>
    </div>
  }
  <p class="b-1 pb-plus">{{ title() }}</p>
  <div
    class="pin-container surface-elevated px-big border-100 py-plus d-flex align-items-center radius-large"
    [ngClass]="
      this.enterPasswordState() === EnterPasswordEnum.WRONG
        ? 'border-color-error'
        : isFocuse()
          ? 'border-color-brand'
          : 'border-color-light'
    "
  >
    <input
      type="password"
      name="password"
      id="password"
      inputmode="numeric"
      (focus)="isFocuse.set(true)"
      (focusout)="isFocuse.set(false)"
      [(ngModel)]="hiddenInputValue"
      (ngModelChange)="hiddenInputChange($event)"
      (keydown)="inputKeyDown($event)"
      class="hidden-input w-100"
      maxlength="4"
      [autocomplete]="pinAutocompleteAttribute()"
    />
    <input
      type="text"
      name="username"
      value="Digipay"
      [autocomplete]="'username'"
      hidden
    />
    <div
      class="pin-divs px-big py-plus"
      (click)="onDivClicked()"
    >
      @for (pin of pinDivs(); track $index) {
        <div class="circle">
          <span [ngClass]="{ 'no-content': pin === '-', 'text-onback-brand': $index === hiddenInputValue().length && this.isFocuse() }">{{
            pin === '-' ? '-' : '●'
          }}</span>
        </div>
      }
    </div>
  </div>
  @if (hint() !== '') {
    <p
      class="text-onback-medium l-3 pt-pony"
      [ngClass]="{ 'text-onback-error': this.enterPasswordState() === EnterPasswordEnum.WRONG }"
    >
      {{ hint() }}
    </p>
  }
</div>
@if (hasBiometric()) {
  <div
    class="d-flex flex-column align-items-center pt-big"
    (click)="enterPinWithBiometric()"
  >
    <span class="biometric-icon"></span>
    <p class="b-2">ورود هوشمند دیجی‌پی</p>
  </div>
}
